module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-1200.a01b664a.svg";